<template>
  <button
    class="flex cursor-pointer select-none items-center pr-1 hover:text-skin-link"
  >
    <i-ho-upload class="text-base" />
    <span class="ml-1 hidden md:block">{{ $t('share') }}</span>
  </button>
</template>
